import { toast, loading } from '@/shared/utils/UIHelper'
import { createSort } from '../utils/queryParam.js'
import _ from 'lodash'

import { SORT_TYPE_NONE } from '../constants/sorts'
import { PAGE_MODE_PAGE, PAGE_MODE_SCROLL } from '../constants/pageModes'

export const usePageMixin = {
  props: {
    limit: {
      type: Number,
      default: 10,
      required: false
    },
    load: {
      type: Function,
      default: () => {},
      required: true
    },
    mode: {
      type: String,
      default: PAGE_MODE_PAGE,
      required: false
    }
  },
  data () {
    return {
      isLoading: false,
      pageIndex: 1,
      totalPages: 0,
      data: [],
      sort: null,
      search: null
    }
  },
  watch: {
    'limit' () {
      this.handleLoad()
    },
    'pageIndex' () {
      this.handleLoad()
    },
    'sort': {
      handler () {
        this.pageIndex = 1
        this.handleLoad()
      },
      deep: true
    }
  },
  beforeMount () {
    this.handleLoad()
  },
  methods: {
    async reload () {
      await this.handleLoad()
    },
    async previous () {
      this.pageIndex--
      await this.handleLoad(this.mode)
    },
    async next () {
      this.pageIndex++
      await this.handleLoad(this.mode)
    },
    async handleLoad (mode = PAGE_MODE_PAGE, forceClear = false) {
      if (!this.isLoading) {
        loading.push()
        this.isLoading = true

        if (forceClear) {
          this.pageIndex = 1
          this.data = []
        }

        const params = {
          page: this.pageIndex - 1,
          size: this.limit
        }

        if (this.search !== null && this.search !== undefined && this.search !== '') params.search = this.search
        if (!_.isNil(this.sort)) params.sort = createSort(this.sort)

        const response = await this.load(params)
          .then(response => {
            const { status, data } = response

            if (status === 200) {
              return {
                data: data.content,
                totalPages: data.totalPages
              }
            }

            toast.error(this.$lang.Common.MicroserviceUnavailable)

            return {
              data: [],
              totalPages: 0
            }
          })
          .catch(() => {
            toast.error(this.$lang.Common.MicroserviceUnavailable)

            return {
              data: [],
              totalPages: 0
            }
          })

        if (response.data && response.data.length > 0) {
          if (mode.toUpperCase() === PAGE_MODE_SCROLL.toUpperCase()) {
            this.data.push(...response.data)
          } else {
            this.data = response.data
          }

          this.totalPages = response.totalPages
        }

        this.isLoading = false
        loading.pop()
      }
    },
    handleSort (field, type) {
      const sort = { field, type }

      switch (type) {
        case SORT_TYPE_NONE:
          this.sort = null
          break
        default:
          this.sort = sort
      }
    },
    handleSearch (event) {
      this.search = event.value
      this.handleLoad(this.mode, true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/nexum/mixins/usePageMixin.js